import {formValidation} from '../../../../ZhbLuzern.Site.Base/node_modules/@form-validation/bundle/lib/popular';
import {SubmitButton} from '../../../../ZhbLuzern.Site.Base/node_modules/@form-validation/plugin-submit-button';
import {DefaultSubmit} from '../../../../ZhbLuzern.Site.Base/node_modules/@form-validation/plugin-default-submit';
import {Trigger} from '../../../../ZhbLuzern.Site.Base/node_modules/@form-validation/plugin-trigger';
import {Message} from '../../../../ZhbLuzern.Site.Base/node_modules/@form-validation/plugin-message';
import {de_DE} from '../../../../ZhbLuzern.Site.Base/node_modules/@form-validation/locales/lib/de_DE';

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('.content-form').forEach(element => {
    const submitButtonElement = element.querySelector('button[type="submit"]');

    formValidation(
      element,
      {
        // We default to de_DE here, not a problem in this project, but could be made dynamic based on html lang
        locale: 'de_DE',
        localization: de_DE,
        // See Neos.Fusion.Form:Runtime.RuntimeForm override in ZhbLuzern.Form
        fields: JSON.parse(element.getAttribute('data-validation-schema')),
        plugins: {
          trigger: new Trigger({
            event: JSON.parse(element.getAttribute('data-trigger-schema')),
            threshold: JSON.parse(element.getAttribute('data-threshold-schema'))
          }),
          message: new Message({
            container: function (field, element) {
              // See FieldContainer*.fusion in ZhbLuzern.Form
              return element.closest('.field__wrap')?.querySelector('.validation-result__container') ?? null;
            }
          }),
          // Validate fields when clicking the Submit button
          submitButton: new SubmitButton(),
          // Submit the form when all fields are valid
          defaultSubmit: new DefaultSubmit(),
        },
      }
    ).on('core.form.valid',function () {
      // disable button on submit
      submitButtonElement.setAttribute('disabled',true);
      submitButtonElement.innerHTML = "Senden..."
    }).on('core.field.invalid', function(event) {
      // add error class to field__wrap div
      document.querySelector("[name='" + event + "'").closest('.field__wrap').classList.add('field--error');
      // remove error class on valid field
    }).on('core.field.valid', function(event) {
      document.querySelector("[name='" + event + "'").closest('.field__wrap').classList.remove('field--error');
    });
  });
})
